import React, { Component } from 'react';
import AppContentComponent from '../../templates/content'
import AppPromotionsCreateComponent from './components/create'
import AppPromotionsUpdateComponent from './components/update'
import AppPromotionsListComponent from './components'
import { Route } from 'react-router-dom'

class AppPromotionsComponent extends Component {

	render() {

		return (
			<AppContentComponent>
				<Route exact path="/app/promotions/create" component={AppPromotionsCreateComponent} />
				<Route exact path="/app/promotions/promotion/:promotion_id" component={AppPromotionsUpdateComponent} />
				<Route exact path="/app/promotions/" component={AppPromotionsListComponent} />
			</AppContentComponent>
		)
	}
}

export default AppPromotionsComponent;


// WEBPACK FOOTER //
// ./src/application/components/promotions/index.js